if (!customElements.get('hfl-guide-background')) {
  customElements.define('hfl-guide-background', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.video.muted = true;
      this.video.playsInline = true;
      this.visible = false;
      this.autoplayBlocked = false;
      const play = () => this.video.play().catch(() => {
        this.autoplayBlocked = true;
      });
      const sync = () => {
        const connection = navigator.connection;
        const saveData = connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '');
        const autoplay = this.dataset.autoplay === 'true' && !this.motion.matches && !saveData;
        if (this.visible && !document.hidden && !this.autoplayBlocked && autoplay) {
          if (this.video.paused) play();
        } else {
          this.video.pause();
        }
      };
      this.motion.addEventListener('change', sync, options);
      document.addEventListener('visibilitychange', sync, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          sync();
        });
        this.observer.observe(this);
      }
      // Without IntersectionObserver, retain the static poster.
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.observer?.disconnect();
      this.video?.pause();
    }
  });
}

if (!customElements.get('hfl-guide-embed')) {
  customElements.define('hfl-guide-embed', class extends HTMLElement {
    connectedCallback() {
      const link = this.querySelector('a');
      const template = this.querySelector('template');
      if (!link || !template) return;
      this.abortController = new AbortController();
      link.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const player = template.content.cloneNode(true);
        link.replaceWith(player);
        this.querySelector('iframe')?.focus();
      }, { signal: this.abortController.signal });
    }
    disconnectedCallback() {
      this.abortController?.abort();
    }
  });
}
